import React, { useState } from 'react'
import { DialogActions, Typography } from '@material-ui/core'

import * as Modal from '_components/modal/generic-modal'
import useStyles from './styles'
import Button from '_/components/button'
import SupportAgentSharpIcon from '@mui/icons-material/SupportAgentSharp'
import { currentServiceOrderSelector } from '_/modules/service-orders/selectors'
import { useSelector } from 'react-redux'
import { Dialog } from '@mui/material'

export function StepExplanation({ htmlString }) {
  return (
    <Typography component="div" variant="body1" dangerouslySetInnerHTML={{ __html: htmlString }} />
  )
}

export function InfoServiceOrderStepStatusModal() {
  const styles = useStyles()
  const serviceOrder = useSelector(currentServiceOrderSelector)
  const [openModal, setOpenModal] = useState(false)

  return (
    <>
      <Button
        className={styles.supportButton}
        onClick={() => setOpenModal(true)}
        color="secondary"
        variant="outlined"
        startIcon={<SupportAgentSharpIcon className={styles.icon} />}
      >
        <Typography>Clique aqui e veja o que fazer agora</Typography>
      </Button>
      <Dialog className={styles.root} open={openModal} onClose={() => setOpenModal(false)}>
        <Modal.TitleModal>
          <Typography className={styles.title}>
            O que fazer na etapa {serviceOrder?.stepDesc}?
          </Typography>
        </Modal.TitleModal>

        <Modal.Content className={styles.dialogContent}>
          <StepExplanation htmlString={serviceOrder?.stepExplanation} />
        </Modal.Content>

        <DialogActions className={styles.actions}>
          <Modal.ButtonFullBlue onClick={() => setOpenModal(false)}>
            Ok, entendi
          </Modal.ButtonFullBlue>
        </DialogActions>
      </Dialog>
    </>
  )
}
